import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { ConfigBaseFilter, ConfigService, ListLayout, ListLayoutMultipleComponent, ListSortOption, SkeletonLoaderLayout } from 'gung-list';
import { filter, Observable } from 'rxjs';
import { GungSettingsApiUsersTableComponent } from '../components/gung-settings/gung-settings-api-users-table/gung-settings-api-users-table.component';
import { ApiUsers, GungSettingsApiUsersService } from './gung-settings-api-users.service';

@Injectable({
  providedIn: 'root'
})
export class GungSettingsApiUserListConfigService implements ConfigService<ApiUsers> {
  private apiUsersService = inject(GungSettingsApiUsersService);

  skeletonLoaderLayout: SkeletonLoaderLayout = 'table';

  getItems(route?: ActivatedRouteSnapshot): Observable<ApiUsers[]> {
    return this.apiUsersService.getApiUsers().pipe(
      filter(users => {
        console.log('users', users);
        return !!users;
      })
    );
  }

  getFilters(route?: ActivatedRouteSnapshot): ConfigBaseFilter<ApiUsers>[] {
    return [];
  }

  getSortOptions(route?: ActivatedRouteSnapshot): ListSortOption<ApiUsers>[] {
    return [];
  }

  getBatchSizes(route?: ActivatedRouteSnapshot): number[] | undefined {
    return [50];
  }
  
  getLayouts(route?: ActivatedRouteSnapshot): ListLayout<ApiUsers>[] {
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => GungSettingsApiUsersTableComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent,
        getName: () => 'list'
      }
    ];
  }

  getSearchTerms(item: ApiUsers): string[] {
    return [item.username];
  }
  
  getItemId(item: ApiUsers): string {
    return item.username;
  }
}
